import { useState } from 'react';
import { connect } from 'react-redux';
import { Form } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import './checkBoxItems.scss';
import _ from 'lodash';

const CheckBoxItems = (props) => {
  let [otherValueState, updateOtherValue] = useState(_.get(props.value, props.entry.otherMapTo));

  let options = useSelector((state) => state.options[props.entry.optionType]);
  let [selectedOptions, updateValue] = useState(
    props.stateData[props.entry.mapTo] ? props.stateData[props.entry.mapTo] : []
  );

  const isOtherOption = (option) => {
    return option.replace(':', '') === props.aditionalName;
  };

  let [otherChecked, updateOtherChecked] = useState(selectedOptions.some(
    (item) => isOtherOption(item.option) && item.type === props.entry.optionType
  ));

  const myChangeHandler = (event) => {
    let mapTo = event.target.name;
    let val = event.target.value;
    updateOtherValue(val);
    props.onChangeHandler(mapTo, val);
  };

  if (!props.entry.optionType && props.options) {
    options = props.options;
  }

  const handleOnChange = (mapTo, option, selected) => {
    let findOption = selected.find((item) => option.id === item.id);
    let index = selected.indexOf(findOption);

    if (index !== -1) {
      selected.splice(index, 1);
      if(isOtherOption(option.option) && option.type === props.entry.optionType) {
        updateOtherChecked(false);
      }
    } else {
      selected.push(option);
      if(isOtherOption(option.option) && option.type === props.entry.optionType) {
        updateOtherChecked(true);
      }
    }

    updateValue(selected);
    props.onChangeHandler(mapTo, selected);
  };

  return (
    <Form.Group style={props.entry.style} className={props.entry.className}>
      {props.entry.label ? <Form.Label>{props.entry.label}</Form.Label> : null}
      <div
        className="radio-checkbox-ctn"
        key={`key-${props.entry.type}-${props.entry.mapTo}-ctn`}
      >
        {options ? options.map((option) => ([
          <Form.Check
            name={props.entry.mapTo}
            inline={props.entry.inline}
            label={option.option}
            type={props.entry.type}
            id={`check-${props.entry.type}-${props.entry.mapTo}-${option.id}`}
            key={`check-${props.entry.type}-${props.entry.mapTo}-${option.id}`}
            defaultChecked={selectedOptions.some(
              (item) => option.id === item.id
            )}
            onChange={() =>
              handleOnChange(props.entry.mapTo, option, selectedOptions)
            }
          />,
          otherChecked && props.entry.includeOther && isOtherOption(option.option) ?
            <Form.Control
              type='text'
              className='other-text'
              name={props.entry.otherMapTo}
              onChange={myChangeHandler}
              value={otherValueState}
              maxLength={props.entry.maxLength??''}
            /> : null
        ])) : null}
      </div>
    </Form.Group>
  );
};



const mapStateToProps = function(state) {
  return {
    stateData : state.pagesData.data.basicInformation
  };
};

export default connect(mapStateToProps)(CheckBoxItems);
